module.exports = __webpack_public_path__ + "img/frame.30f2c35e.png";